// extracted by extract-css-chunks-webpack-plugin
module.exports = {"userTable":"UserTable__userTable___366pB","windowScrollerWrapper":"UserTable__windowScrollerWrapper___3CUVB","stickyUserTableRows":"UserTable__stickyUserTableRows___2ytQ1"};
    if(module.hot) {
      // 1778083500812
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  